import { Injectable } from "@angular/core";
import { environment } from "environments/environment";

@Injectable({ providedIn: "root" })
export class GoogleMapsLoaderService {
  private _loaded: Promise<void>;

  load(): Promise<void> {
    if (!this._loaded) {
      this._loaded = new Promise<void>((resolve) => {
        if (typeof google !== "undefined" && google.maps) {
          resolve();
          return;
        }
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleMapsKey}`;
        script.async = true;
        script.onload = () => resolve();
        document.body.appendChild(script);
      });
    }
    return this._loaded;
  }

  get isLoaded(): boolean {
    return typeof google !== "undefined" && !!google.maps;
  }
}
